/** @jsxImportSource @emotion/react */

import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

import tw from "twin.macro";

import { CalciteLoader } from "@esri/calcite-components-react";

const Login: React.FC = () => {
  useEffect(() => {
    onLogin();
  }, []);

  function onLogin() {
    const url = new URL(
      `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_REALM}/protocol/openid-connect/auth`
    );
    url.searchParams.append("response_type", "code");
    url.searchParams.append("client_id", process.env.REACT_APP_CLIENT_ID || "");
    url.searchParams.append("scope", "openid profile");
    url.searchParams.append("state", uuidv4());
    url.searchParams.append(
      "redirect_uri",
      process.env.REACT_APP_REDIRECT_URI || ""
    );
    url.searchParams.append("nonce", uuidv4());

    //make a redirect to the keycloak login page with the url above
    window.location.replace(url);
  }

  return (
    <div
      css={[tw`flex flex-col items-center justify-center h-screen relative`]}
    >
      <CalciteLoader label={"Loading"} />
    </div>
  );
};

export default Login;
